<template>
  <v-container>
    <v-row>
      <div class="md-card md-theme-default">
        <div class="md-card-content">
          <div>
            <div class="header_title">
              <v-row no-gutters class="ma-3 header_title">
                <v-col cols="12" md="2" class="pt-6">
                  External Tickets
                  <br />
                  <br />
                </v-col>

                <v-col cols="12" md="10">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="12" md="2" sm="1" class="text-right">
                      <v-btn
                        height="38"
                        class="green-color"
                        width="100%"
                        dark
                        @click="addExternalTicket"
                      >
                        Add Ticket
                        <v-icon right dark>mdi-plus-circle</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div
              class="md-content md-table md-theme-default table_borders"
              table-header-color="orange"
              value
            >
              <div
                class="
                  md-content md-table-content md-scrollbar md-theme-default
                "
              >
                <table>
                  <thead class="md-card-header">
                    <tr>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Ticket</div>
                        </div>
                      </th>

                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">User</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Booking Date</div>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      class="md-table-row"
                      v-for="(data, index) in tickets"
                      :key="index"
                    >
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          <v-btn
                            small
                            color="#00b0af"
                            class="d-inline-block text-truncate"
                            style="
                          max-width: 130px;
                          min-width: 130px;
                          text-transform: none;
                        "
                            dark
                            :href="data.ticket"
                            target="_blank"
                          >
                            <span class="text-truncate" style="margin-top:8px;">
                              {{ data.name }}
                            </span>
                          </v-btn>
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          <v-btn
                            v-if="data.user_id"
                            small
                            color="#00b0af"
                            class="d-inline-block text-truncate"
                            style="
                          max-width: 130px;
                          min-width: 130px;
                          text-transform: none;
                        "
                            dark
                            @click="
                              $router.push({
                                name: 'ViewUser',
                                params: { userId: data.user_id },
                              })
                            "
                          >
                            <span class="text-truncate">{{
                              data.user
                            }}</span></v-btn
                          >
                          <span v-else>NA</span>
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.user_id ? data.booking_date : "NA" }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="totalPages"
              :page="page"
              total-visible="10"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-row>
    <v-dialog
      v-model="addTicketModel"
      persistent
      max-width="40%"
      scrollable
      v-resize="onResize"
    >
      <v-card ref="card">
        <v-card-title class="headline"
          >{{ editFlag ? "Update" : "Add" }} Ticket</v-card-title
        >
        <v-card-text class="form_bg">
          <v-container>
            <v-form v-on:submit.prevent ref="form" v-model="valid">
              <v-row>
                <v-col sm="6">
                  <v-file-input
                    :prefix="
                      editFlag == true &&
                      ticketForm.ticket_path != null &&
                      ticketForm.ticket != null
                        ? ticketForm.ticket.substring(0, 30) + '..'
                        : ''
                    "
                    :label="editFlag ? '' : 'Select File'"
                    v-model="ticketForm.ticket_path"
                    prepend-inner-icon="mdi-paperclip"
                    prepend-icon
                    outlined
                    background-color="#fff"
                    text-truncate
                    required
                    :rules="[(v) => !!v || 'Document is required']"
                    @change="documentChange()"
                    multiple
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-2 white--text blue-color"
            text
            @click="addUpdateTicket"
            >{{ editFlag ? "Update" : "Add" }} Ticket</v-btn
          >

          <v-btn class="ma-2 white--text green-color" text @click="cancelForm"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <user-model v-bind="UserModel" @close="UserModel.userID = null" />
  </v-container>
</template>
<script>
import UserModel from "../Users/User/UserModel";
export default {
  components: {
    UserModel,
  },
  data() {
    return {
      addTicketModel: false,
      ticketForm: {},
      ticket_path: [],
      tickets: [],
      page: 1,
      totalPages: 1,
      valid: true,
      sortOrder: "asc",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => (v && v.length >= 6) || "Min 6 characters",
      },
      editFlag: false,
      height: 500,
      UserModel: { userID: null, type: "details" },
    };
  },
  mounted() {
    this.getTickets();
  },
  computed: {},
  watch: {
    page() {
      this.getTickets();
    },
  },
  methods: {
    documentChange() {
      this.ticketForm.ticket = null;
    },
    getTickets() {
      let url =
        "settings/external-tickets?sort_order=" +
        this.sortOrder +
        "&per_page=10&page=" +
        this.page;
      this.$http
        .get(url)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.tickets = response.data.data;
            this.totalPages = response.data.total_pages;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    addExternalTicket() {
      this.ticketForm = {};
      this.ticketForm.ticket_path = null;
      this.addTicketModel = true;
      this.data = [];
      setTimeout(() => {
        this.$refs.form.resetValidation();
      });
    },

    addUpdateTicket() {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please complete all required fields");
        return;
      }
      let formData = new FormData();

      let i = 0;
      this.ticketForm.ticket_path.forEach(function(arr) {
        console.log("hhhhh");
        console.log(arr);
        formData.append(`ticket_path[${i}]`, arr);
        i++;
      });

      this.$http({
        url:
          "settings/external-tickets" +
          (this.ticketForm.id ? `/${this.ticketForm.id}` : ""),
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}",
        },
      })
        .then((response) => {
          if (response.status == 200) {
            this.addTicketModel = false;
            this.showSuccess("Ticket Added Successfully.");
            this.getTickets();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    cancelForm() {
      this.$refs.form.resetValidation();
      this.addTicketModel = false;
      this.ticketForm = {};
      this.editFlag = false;
    },

    onResize() {
      if (this.$refs.card) this.height = this.$refs.card.$el.clientHeight - 100;
    },
  },
};
</script>
<style scoped>
.validation-message {
  color: red;
  font-size: 12px;
}
.md-card {
  margin: 0 0 25px 0;
}
.hoverImage {
  background-color: rgba(54, 54, 54, 0.342);
}
</style>
